export default "__VITE_ASSET__jAb$8PQx__"